import {  useEffect } from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Bookkeeping from "./pages/Bookkeeping/Bookkeeping";
import Consulting from "./pages/Consulting/Consulting";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Payroll from "./pages/Payroll/Payroll";
import Registration from "./pages/Registration/Registration";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NewBusinessRegistrationChecklist from "./pages/Resources/NewBusinessRegistrationChecklist";
import FinanceTracker from "./pages/Resources/FinanceTracker";

function App() {
  let location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
        });
      });
    });
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bookkeeping" element={<Bookkeeping />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payroll" element={<Payroll />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/registration" element={<Registration />} />
        <Route
          path="/resources/new-business-registration-checklist"
          element={<NewBusinessRegistrationChecklist />}
        />
        <Route path="/resources/finance-tracker" element={<FinanceTracker />} />
        <Route path="/*" element={<Navigate replace to="/" />} />;
      </Routes>
    </div>
  );
}

export default App;
